import { useEffect, useState } from "react"
import { Flex, List } from "@chakra-ui/react"
import { useSession } from "next-auth/react"
import { useGlobalState } from "providers/globalState"
import { getSiteByLocale } from "services/sites"
import { convertFlatMenuToStructuredTree, filterMenuByUserStatus } from "util/helpers"
import { cmsRequest } from "services/craft/craft"
import MenuItem from "components/nav/menuItem"
import auxiliaryMenuQuery from "services/craft/queries/auxiliaryMenu"

export default function AuxiliaryMenu({ isMobile = false, mobileMenuToggle }) {
    const { locale } = useGlobalState()
    const { data: session } = useSession()
    const user = session?.user
    const [menuItems, setMenuItems] = useState([])

    useEffect(() => {
        const siteConfig = getSiteByLocale(locale)
        if (!siteConfig?.craftId) return

        cmsRequest(auxiliaryMenuQuery, { siteId: siteConfig.craftId })
            .then(data => {
                if (data?.flatmenu) {
                    setMenuItems(convertFlatMenuToStructuredTree([...data.flatmenu]))
                }
            })
            .catch(err => {
                console.error("Failed to fetch auxiliary menu:", err)
            })
    }, [locale])

    const filteredItems = filterMenuByUserStatus(menuItems, user)

    if (!filteredItems.length) return null

    if (isMobile) {
        return (
            <List.Root className="auxiliaryMenu">
                {filteredItems.map((item, index) => (
                    <MenuItem
                        key={item.id ?? index}
                        item={item}
                        isMobile={true}
                        mobileMenuToggle={mobileMenuToggle}
                        className={item.className + " auxiliaryMenu__item"}
                    />
                ))}
            </List.Root>
        )
    }

    return (
        <Flex as={List.Root} direction="row" gap={6} alignItems="center">
            {filteredItems.map((item, index) => (
                <MenuItem key={item.id ?? index} item={item} className={item.className + " auxiliaryMenu__item"} />
            ))}
        </Flex>
    )
}
